/**
 * D&D 5e SRD Conditions
 * Conditions alter a creature's capabilities in a variety of ways
 * and can arise as a result of spells, class features, monster attacks, or other effects.
 */

export type ConditionName =
  | 'blinded'
  | 'charmed'
  | 'deafened'
  | 'exhaustion'
  | 'frightened'
  | 'grappled'
  | 'incapacitated'
  | 'invisible'
  | 'paralyzed'
  | 'petrified'
  | 'poisoned'
  | 'prone'
  | 'restrained'
  | 'stunned'
  | 'unconscious';

export interface Condition {
  id: ConditionName;
  name: string;
  description: string;
  effects: string[];
  /** For exhaustion, describes the levels */
  levels?: ExhaustionLevel[];
  /** Related conditions that this condition also applies */
  includesConditions?: ConditionName[];
  /** Common sources of this condition */
  commonSources?: string[];
}

export interface ExhaustionLevel {
  level: number;
  effect: string;
}

export const CONDITION_NAMES: ConditionName[] = [
  'blinded',
  'charmed',
  'deafened',
  'exhaustion',
  'frightened',
  'grappled',
  'incapacitated',
  'invisible',
  'paralyzed',
  'petrified',
  'poisoned',
  'prone',
  'restrained',
  'stunned',
  'unconscious',
];
